@if (enabled) {
<section [class]="sectionClass()" aria-labelledby="dev-quick-login-title">
    <div class="flex flex-wrap items-center gap-2">
        <h2 id="dev-quick-login-title" class="text-sm font-semibold text-primary">Quick login</h2>
        <p class="m-0 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 dark:bg-amber-900/60 dark:text-amber-100">
            Dev</p>
    </div>
    <p class="mt-1 text-xs text-secondary">Select a user to sign in. Shows the last 5 accounts on this browser.</p>

    @if (users().length === 0) {
    <p class="mt-3 text-sm text-secondary">Sign in once and that account will show up here.</p>
    } @else {
    <ul class="mt-3 flex flex-col gap-2">
        @for (user of users(); track user.email) {
        <li class="flex items-stretch gap-2">
            <button type="button"
                class="flex min-w-0 flex-1 flex-col rounded-md border border-zinc-200 bg-white px-3 py-2 text-left hover:bg-zinc-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600 disabled:cursor-not-allowed disabled:opacity-50 dark:border-zinc-700 dark:bg-zinc-900 dark:hover:bg-zinc-800"
                [disabled]="busy()" (click)="loginAs(user)">
                <p class="m-0 truncate text-sm font-medium text-primary">{{ user.label }}</p>
                @if (user.kind) {
                <p [class]="kindBadgeClass(user.kind)">{{ kindLabel(user.kind) }}</p>
                }
                @if (user.organisation) {
                <p class="m-0 truncate text-xs text-secondary">{{ user.organisation }}</p>
                }
                @if (user.label !== user.email) {
                <p class="m-0 truncate text-xs text-secondary">{{ user.email }}</p>
                }
            </button>
            <button type="button"
                class="rounded-md px-3 text-sm text-secondary hover:bg-zinc-100 hover:text-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600 disabled:cursor-not-allowed disabled:opacity-50 dark:hover:bg-zinc-800"
                [disabled]="busy()" (click)="removeUser(user)"
                [attr.aria-label]="'Remove ' + user.label + ' from quick login'">
                Remove
            </button>
        </li>
        }
    </ul>
    }
</section>
}
